module.exports = __webpack_public_path__ + "static/img/yAxis.a2e8a04a.svg";